export interface Project {
  title: string
  description: string
  link?: string
  technologies: string[]
  role: string
  outcome: string
}

export const projects: Project[] = [
  {
    title: 'Closing the Conversion Gap: A Strategic IA Overhaul',
    description:
      'High-intent users were dropping off due to excessive Interaction Cost and navigation friction that violated Hick’s Law.',
    technologies: [
      'HTML',
      'SCSS',
      'JavaScript',
      'Information Architecture (IA)',
      'WordPress',
    ],
    role: 'UX Engineer (Lead Design & Code Implementation)',
    outcome:
      '\n25% Increase in lead conversion.\n60% Reduction in interaction cost.',
  },
  {
    title: 'Modular Filtering Framework',
    description:
      'Fragmented enterprise filters were causing "Filter Fatigue" and high Interaction Cost. I engineered a "Single-Point-of-Control" library to unify dense data workflows through modular scheduling and filtering components.',
    technologies: [
      'Angular',
      'SCSS',
      'Node/NPM',
      'System Architecture',
      'Design System',
    ],
    role: 'UX Engineer (Lead Architecture & Distribution)',
    outcome:
      '\nReduced interaction cost by ~40% (Modelled).\nDelivered a production-ready private NPM/Node package that established the foundation for a company-wide Custom Design System.',
  },
  {
    title: 'UX Architecture for Precision Agriculture',
    description:
      'Designing a high-visibility, geospatial scouting mobile experience to bridge the gap between field-level pest detection and executive decision-making.',
    link: 'https://apps.apple.com/za/app/scoutlens/id1588691501',
    technologies: ['Ionic', 'Angular', 'Figma', 'Geospatial Mapping', 'AgTech'],
    role: 'UX Designer / UX Engineer',
    outcome:
      '\nReduced decision-making lag through an integrated Spray Recommendation engine.\nDesigned a high-visibility, geospatial scouting proof of concept to bridge the gap between field-level pest detection and executive decision-making.',
  },
  {
    title: 'Eliminating the Repetitive Entry Bottleneck',
    description:
      'Architected a Proof of Concept for a Pallet QC module - shifting from repetitive manual data entry to a streamlined, scan-integrated system in a high-pressure packhouse environment.',
    technologies: ['Angular', 'Figma', 'UX/UI Design', 'Information Architecture'],
    role: 'UX Designer',
    outcome:
      '\nTwo-stage functional lifecycle (Setup & Inspection) reduced per-pallet handling time.\nEnsured audit-ready data integrity by replacing manual entry with scanning to reduce fatigue and error rates.',
  },
]
